import React, { useMemo } from "react";
import { TableSearch } from "../../../components/form/Fields";
import CommonButton from "../../../components/commonButton";
import { PlusIcon } from "../../../assets/icons";
import { formatMomentDate } from "../../../utils/dateHelper";
import { BankIcons } from "../../../utils/otherHelopers";
import CustomTable from "../../../components/table/CustomTable";
import StatusChip from "../../../components/statusChip/StatusChip";

const Listing = ({
  data,
  isLoading,
  searchTerm,
  setSearchTerm,
  setCurrentPage,
  addUserHandler,
  handleEdit,
  handleView,
  handleChangePassword,
  handleUserApproveOrReject,
  handleStatusToggle,
  canCreate,
  canUpdate,
  canVerify,
  pagination,
}) => {
  const columns = useMemo(() => [
    {
      id: "name",
      header: "NAME",
      cell: (_, row) => row?.name || "-",
    },
    {
      id: "mobile_number",
      header: "MOBILE NUMBER",
      cell: (_, row) => row?.mobile_number || "-",
    },
    {
      id: "email",
      header: "EMAIL",
      cell: (_, row) => row?.email || "-",
    },
    {
      id: "designation",
      header: "DESIGNATION",
      cell: (_, row) => row?.designation || "-",
    },
    {
      id: "bank",
      header: "BANK",
      cell: (_, row) => row?.bank ? (
        <div className="text-start d-flex align-items-center gap-1">
          {row?.bank?.logo?.url ? (
            <img
              src={row.bank.logo.url}
              alt={row.bank.name}
              style={{ width: 40, height: 40, marginRight: 6, objectFit: "contain" }}
            />
          ) : (
            BankIcons(row?.bank?.name)
          )}
          <span>{row.bank.name}</span>
        </div>
      ) : "-",
    },
    {
      id: "branch",
      header: "BRANCH",
      cell: (_, row) => row?.branch ? row.branch.name : "-",
    },
    {
      id: "created_at",
      header: "CREATED AT",
      cell: (_, row) => row?.createdAt ? (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
          <span>{formatMomentDate(row.createdAt, "DD MMM YYYY")}</span>
          <span>{formatMomentDate(row.createdAt, "hh:mm A")}</span>
        </div>
      ) : "-",
    },
    {
      id: "status",
      header: "STATUS",
      cell: (_, row) => row?.status ? (
        <StatusChip
          pill
          bg={
            row.status === "pending"
              ? "warning"
              : row.status === "approved"
                ? "success"
                : row.status === "rejected"
                  ? "danger"
                  : ""
          }
          title={row.status}
          className="text-capitalize"
        />
      ) : "-",
    },
    {
      id: "is_active",
      header: "ACTIVE STATUS",
      cell: (_, row) => (
        <StatusChip
          bg={row?.is_active ? "success" : "danger"}
          pill
          title={row?.is_active ? "Active" : "Inactive"}
          className={canUpdate ? "cursor-pointer" : ""}
          onClick={(e) => {
            e.stopPropagation();
            if (canUpdate) {
              handleStatusToggle(row);
            }
          }}
        />
      ),
    },
  ], [canUpdate, handleStatusToggle]);

  const actionList = useMemo(() => [
    {
      title: "View",
      handler: (row) => handleView?.(row),
    },
    {
      title: "Approve",
      isVisible: (row) => canVerify && (row.status === "pending" || row.status === "rejected"),
      handler: (row) => handleUserApproveOrReject?.("approved", row),
    },
    {
      title: "Reject",
      isVisible: (row) => canVerify && (row.status === "pending" || row.status === "approved"),
      handler: (row) => handleUserApproveOrReject?.("rejected", row),
    },
    {
      title: "Edit",
      isVisible: () => canUpdate,
      handler: (row) => handleEdit?.(row),
    },
    {
      title: "Change Password",
      isVisible: () => canUpdate,
      handler: (row) => handleChangePassword?.(row),
    },
  ], [canVerify, canUpdate, handleView, handleUserApproveOrReject, handleEdit, handleChangePassword]);

  return (
    <>
      <div className="p-4 d-flex align-items-center justify-content-between gap-4">
        <TableSearch
          value={searchTerm}
          placeholder="Search User"
          onChange={(e) => {
            setSearchTerm(e.target.value);
            setCurrentPage(1);
          }}
        />
        <div className="d-flex gap-2">


          {canCreate && (
            <CommonButton
              icon={<PlusIcon />}
              title="User"
              type="button"
              onClick={(e) => {
                e.stopPropagation();
                addUserHandler();
              }}
            />
          )}
        </div>
      </div>

      <CustomTable
        data={data || []}
        columns={columns}
        loading={isLoading}
        emptyMessage="No bank users found"
        keyField="id"
        actionList={actionList}
        pagination={pagination}
      />
    </>
  );
};

export default Listing;
